import { render, staticRenderFns } from "./newPageIndex.vue?vue&type=template&id=34fa8fe2&scoped=true"
import script from "./newPageIndex.vue?vue&type=script&lang=js"
export * from "./newPageIndex.vue?vue&type=script&lang=js"
import style0 from "./newPageIndex.vue?vue&type=style&index=0&id=34fa8fe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fa8fe2",
  null
  
)

export default component.exports